import { useState } from "react";
import HamburgerSvg from "../SVG/Hamburger";
import "./hamburgermenu.scss";
import Logo from "../SVG/LogoSvg";
import HamOpen from "../SVG/HamburgerOpen";
import { NavLink } from "react-router-dom";
import Navigation from "../../components/Navigation";
import Button from "../Button";
import { useGlobalContent } from "../../context/GlobalContext";
import { resolveLink } from "../../helpers/resolveLink";
import { GetYear } from "../../helpers/getYear";

const HamburgerMenu = () => {
  const year = GetYear();
  const [toggle, setToggle] = useState(false);
  const { menuItems, socials, phone, email } = useGlobalContent();
  function clickhandller() {
    return setToggle(!toggle);
  }
  return (
    <>
      <nav className={`hamburger-menu ${toggle ? "" : ""}`}>
        <NavLink className="logo" to="/" onClick={() => setToggle(false)}>
          <Logo className="logo" />
        </NavLink>
        <div className="hamburger " onClick={() => clickhandller()}>
          <div className={`dot ${toggle ? "active" : ""}`}></div>
          {toggle ? <HamOpen /> : !toggle ? <HamburgerSvg /> : ""}
        </div>
      </nav>
      <div className={`listNav ${toggle ? "" : "none"}`}>
        <div className="container-sec">
          <ul className="footer-nav">
            <Navigation
              items={menuItems}
              onLinkClick={() => clickhandller()}
              itemWrapper="li"
            />
          </ul>
        </div>
        <div className="container-third">
          <div className="social-container">
            {socials.map((social) => {
              const { href, target } = resolveLink(social.link);
              return (
                <Button
                  key={social._uid}
                  link={href}
                  target={target}
                  label={social.title}
                  noIcon
                />
              );
            })}
          </div>
          <div className="contact-container">
            {phone && <Button link={`tel:${phone}`} label={phone} noIcon />}
            {email && (
              <Button link={email} emailType="email" label={email} noIcon />
            )}
          </div>
        </div>
        <div className="container-fourth">
          <p className="rights">©{year} All Rights reserved</p>
        </div>
      </div>
    </>
  );
};
export default HamburgerMenu;
